import React, { useEffect, useState } from "react"
import CountUp from "react-countup"
import "./numbers.sass"
import VisibilitySensor from "react-visibility-sensor"
import classNames from "classnames"
import { defaultIntl, _isMobile } from "../../utils"

export default ({ intl = defaultIntl }) => {
  const init = 100
  const [visible, setVisible] = useState(0)
  const [count1, setCount1] = useState(init)
  const [count2, setCount2] = useState(init)
  const [count3, setCount3] = useState(init)
  const isMobile = _isMobile()
  useEffect(() => {
    if (visible < 1) {
      setTimeout(() => {
        setCount1(2000000)
        setCount2(32000)
        setCount3(25000)
      }, 500)
    }
  }, [visible])
  return (
    <VisibilitySensor onChange={v => setVisible(visible + 1)}>
      <div className="partner-numbers">
        <div className="container">
          <div className="columns">
            <div className={classNames("column animated delay-0-1s", { fadeInUp: visible })}>
              <figure>{isMobile ? count1 : <CountUp end={count1} duration={3} separator="," />}+</figure>
              <h4>{intl.formatMessage({ id: "partner.numbers.a.title" })}</h4>
              <p> {intl.formatMessage({ id: "partner.numbers.a.desc" })}</p>
            </div>
            <div className={classNames("column animated delay-0-1s", { fadeInUp: visible })}>
              <figure>{isMobile ? count2 : <CountUp end={count2} duration={3} separator="," />}+</figure>
              <h4>{intl.formatMessage({ id: "partner.numbers.b.title" })}</h4>
              <p> {intl.formatMessage({ id: "partner.numbers.b.desc" })}</p>
            </div>
            <div className={classNames("column animated delay-0-1s", { fadeInUp: visible })}>
              <figure>{isMobile ? count3 : <CountUp end={count3} duration={3} separator="," />}+</figure>
              <h4>{intl.formatMessage({ id: "partner.numbers.c.title" })}</h4>
              <p> {intl.formatMessage({ id: "partner.numbers.c.desc" })}</p>
            </div>
          </div>
        </div>
      </div>
    </VisibilitySensor>
  )
}
